(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    function updateSoundButton(button, video) {
    button.setAttribute('aria-pressed', String(!video.muted));
    button.setAttribute('title', video.muted ? button.dataset.soundOff : button.dataset.soundOn);
  }

  document.addEventListener('volumechange', (event) => {
    if (event.target.tagName !== 'VIDEO') return;
    const button = event.target.closest('video-element')?.querySelector('[data-video-sound-toggle]');
    if (button) updateSoundButton(button, event.target);
  }, true);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-video-sound-toggle]');
    if (!button) return;
    const video = button.closest('video-element').querySelector('video');
    if (!video) return;
    event.preventDefault();
    event.stopPropagation();
    const enableSound = video.muted;
    if (enableSound) {
      document.querySelectorAll('video-element:has([data-video-sound-toggle]) video').forEach((other) => {
        if (other !== video) other.muted = true;
      });
      video.volume = 1;
    }
    video.muted = !enableSound;
    updateSoundButton(button, video);
    if (enableSound) {
      const playback = video.play();
      if (playback) playback.catch(() => {
        video.muted = true;
        updateSoundButton(button, video);
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
